import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import IconPinkStar from '@/assets/app/images/icon/icon-pink-star.png';
import { motion } from 'framer-motion';
import TitleHeader from '../common/TitleHeader';
import { eulReul, vAppAjax } from '@/shared/utils/CommonUtil';
import logger from '@/shared/utils/Logger';

interface Achievement {
  id: string;
  category: string;
  name: string;
  description: string;
  current: number;
  total: number;
  color: string;
  icon: string;
}

const Achievements: React.FC = () => {
  const navigate = useNavigate();
  const [data, setData] = useState<CompletedInfo>();

  const loadData = async () => {
    await vAppAjax(
      'get',
      `my/achievements`,
      {},
      (response: AxiosResponse<CommonResult<CompletedInfo>>) => {
        const resultData = response.data;
        if (resultData.code === 200) {
          setData(response.data.result);
        } else {
          logger.warn(resultData.message);
        }
      },
      (error: any) => {
        logger.error(error);
      },
    );
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <TitleHeader title="나의 업적" onBack={() => navigate(-1)} />

      <main className="px-4 space-y-4">
        {/* 상단 요약 카드 */}

        {data?.personName && (
          <div className={`flex items-center justify-center gap-3 mb-2 theme-${data.themeColor}`}>
            <span className="px-3 py-0.5 border border-[#F3A9C9] text-[#F3A9C9] text-xs font-bold rounded-full">
              최근
            </span>
            <span className="text-sm font-medium" style={{ color: 'var(--color-btn)' }}>
              {data.categoryName} · {data.personName} · {data.chapterTitle}
            </span>
          </div>
        )}

        <div className="flex items-center justify-center border border-white f-one-pop bg-[#F3A9C9] text-white rounded-[50px] w-100p py-3 mt-3 mx-auto">
          <div className="flex-1 text-center">
            <div className="text-[24px] font-extrabold">
              {data?.completedPerson || 0} / {data?.totalPerson}
            </div>
            <div className="text-[14px]">완료한 인물</div>
          </div>

          <div className="w-[0.5px] h-[42px] bg-[#efefef]"></div>

          <div className="flex-1 text-center">
            <div className="text-[24px] font-extrabold ">
              {data?.completedEra || 0} / {data?.totalEra}
            </div>
            <div className="text-[14px]">완료한 시대</div>
          </div>
        </div>

        {/* 리스트 */}
        <div className="space-y-1" style={{ borderBottom: '1px solid #f2f2f2' }}>
          {[
            ...(data?.achievements.filter(item => !item.isAllCompleted) || []),
            ...(data?.achievements.filter(item => item.isAllCompleted) || []),
          ].map((item, idx) => (
            <div
              key={idx}
              className={`bg-white py-4 flex items-center gap-4 theme-${item.themeColor}`}
              style={{ borderColor: '#F2F2F2', borderTop: '1px solid #f2f2f2' }}
            >
              <div
                className={`w-20 px-2 py-2 rounded-[25px] flex items-center justify-center text-white font-bold text-sm shrink-0`}
                style={{ background: `var(--color-btn)`, height: 34 }}
              >
                {item.categoryName.replace('시대', '')}
              </div>
              <div className="flex-1">
                <p
                  className="text-sm font-bold mb-1"
                  style={{ color: item.isAllCompleted ? '#F3A9C9' : '' }}
                >
                  {item.isAllCompleted ? (
                    <>
                      <span className="flex items-center">
                        달성완료&nbsp;
                        <img src={IconPinkStar} className="w-4 h-4 object-contain inline-block" />
                      </span>
                    </>
                  ) : (
                    `${item.personName} 등장`
                  )}
                </p>
                <div className="flex items-center gap-2">
                  <div
                    className="h-[16px] rounded-full  overflow-hidden"
                    style={{
                      width: 200,
                      backgroundColor:
                        item.completedChapters === item.totalChapters
                          ? '#DEF0FB'
                          : 'var(--color-area-bg)',
                    }}
                  >
                    <motion.div
                      initial={{ width: 0 }}
                      animate={{ width: `${(item.completedChapters / item.totalChapters) * 100}%` }}
                      className="h-full rounded-lg"
                      style={{
                        backgroundColor:
                          item.completedChapters === item.totalChapters
                            ? '#F3A9C9'
                            : 'var(--color-btn)',
                      }}
                    />
                  </div>
                  <span
                    className="text-xs font-bold"
                    style={{ color: item.isAllCompleted ? '#F3A9C9' : '#0094EF' }}
                  >
                    {item.completedChapters}/{item.totalChapters}
                  </span>
                </div>
                {!item.isAllCompleted && (
                  <p className="mt-1 text-[#868686] text-[10px]">
                    {item.completedChapters === 0
                      ? `${eulReul(item.categoryName)} 클리어 하세요.`
                      : `${eulReul(item.chapterTitle)} 완료하세요.`}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
};

export default Achievements;
